import { ToolType } from 'types/tools/ToolType';

export default function getToolTypeLabel(toolType: ToolType): string {
  switch (toolType) {
    case ToolType.PREVERIFIED_LCA_TOOL:
      return 'Pre-verified LCA tool';
    case ToolType.PREVERIFIED_EPD_TOOL:
      return 'Pre-verified EPD tool';
    case ToolType.FULLY_PREVERIFIED_TOOL:
      return 'Fully pre-verified EPD tool';
    default:
      throw new Error(`Unknown tool type '${toolType}'.`);
  }
}
